var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#659EF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 23.5737V16.8415C41 16.6183 40.9113 16.4043 40.7535 16.2465C40.5957 16.0887 40.3817 16 40.1585 16H33.4263C33.2596 15.9997 33.0966 16.0489 32.958 16.1413C32.8193 16.2338 32.7112 16.3653 32.6474 16.5193C32.5836 16.6732 32.5669 16.8427 32.5995 17.0061C32.6321 17.1696 32.7125 17.3196 32.8305 17.4373L35.6025 20.2076L16 39.8084L17.1916 41L36.7924 21.3975L39.5627 24.1695C39.6804 24.2875 39.8304 24.3679 39.9939 24.4005C40.1573 24.4331 40.3268 24.4164 40.4807 24.3526C40.6347 24.2888 40.7662 24.1807 40.8587 24.042C40.9511 23.9034 41.0003 23.7404 41 23.5737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.cfcf0f17376aa6ed226c27f5396eb2e7.svg";
export { ForwardRef as ReactComponent };